const MouseEvent = Object.freeze({
  enter: 'enter',
  leave: 'leave',
})

export default MouseEvent
